import { createFileRoute } from '@tanstack/react-router'

import { CarrierReconcilePage } from '#/modules/carrier-reconcile'

export const Route = createFileRoute('/_shell/carrier-reconcile')({
  component: CarrierReconcilePage,
})
